export const ReplenishRoute = {
  ElectricityReplenish: (): string => '/dashboard/balance/electricity/replenish',
  
};
